export const MeasurementTypesDictionary = {
  bloodPressure: 'blood_pressure',
  pulse: 'pulse',
  oxygenFlow: 'oxygen_flow',
  saturation: 'saturation',
};
export const SYSTOLIC = 'systolic';
export const DIASTOLIC = 'diastolic';
export const bloodPressureAndPulseTypes = [
  MeasurementTypesDictionary.bloodPressure,
  MeasurementTypesDictionary.pulse,
];
export const oxygenFlowAndSaturationTypes = [
  MeasurementTypesDictionary.oxygenFlow,
  MeasurementTypesDictionary.saturation,
];

export const getBloodPressureAndPulseLineColor = (primary?: string) => [
  '#484848',
  '#D64343',
  primary || '#2F8FA9',
];

export const MEASUREMENT_TABLE_INTERVAL_IN_HOURS = 6;

export enum MEASUREMENT_CLASS {
  MeasurementNodeResult = 'MeasurementNodeResult',
  MultipleChoiceNodeResult = 'MultipleChoiceNodeResult',
}

export enum MEASUREMENT_TYPES {
  BLOOD_PRESSURE = 'BLOOD_PRESSURE',
  PULSE = 'PULSE',
  RESPIRATORY_RATE = 'RESPIRATORY_RATE',
  TEMPERATURE = 'TEMPERATURE',
  OXYGEN_FLOW = 'OXYGEN_FLOW',
  SATURATION = 'SATURATION',
  LEVEL_OF_CONSCIOUSNESS = 'LEVEL_OF_CONSCIOUSNESS',
  WEIGHT = 'WEIGHT',
}

export const measurementTypes = [
  MEASUREMENT_TYPES.BLOOD_PRESSURE,
  MEASUREMENT_TYPES.PULSE,
  MEASUREMENT_TYPES.SATURATION,
  MEASUREMENT_TYPES.RESPIRATORY_RATE,
  MEASUREMENT_TYPES.OXYGEN_FLOW,
  MEASUREMENT_TYPES.WEIGHT,
  MEASUREMENT_TYPES.TEMPERATURE,
  MEASUREMENT_TYPES.LEVEL_OF_CONSCIOUSNESS,
];

export const RECEIVING_OXYGEN = 'RECEIVING_OXYGEN';

export enum SCORE_TYPES {
  EWS = 'EWS',
  TOBS = 'TOBS',
}

export const scoreTypes = [SCORE_TYPES.EWS, SCORE_TYPES.TOBS];

export const CopyOrderOfMeasurementTypes: string[] = [
  MEASUREMENT_TYPES.RESPIRATORY_RATE,
  MEASUREMENT_TYPES.SATURATION,
  MEASUREMENT_TYPES.OXYGEN_FLOW,
  MEASUREMENT_TYPES.PULSE,
  MEASUREMENT_TYPES.BLOOD_PRESSURE,
  MEASUREMENT_TYPES.LEVEL_OF_CONSCIOUSNESS,
  MEASUREMENT_TYPES.TEMPERATURE,
  MEASUREMENT_TYPES.WEIGHT,
  SCORE_TYPES.EWS,
  SCORE_TYPES.TOBS,
];
